module.exports = __webpack_public_path__ + "static/media/map-left-nav.97c7aada.svg";